module.exports = __webpack_public_path__ + "static/secondary-8a9f2e715e4d2d5d62bbc1dc9ec41327.png";